import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Undo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5362 13.2576C18.4159 8.28247 12.2643 6.47626 8.63224 10.056L5.5096 13.1336L5.50962 9.67156C5.50962 9.39542 5.28576 9.17156 5.00962 9.17156C4.73348 9.17156 4.50962 9.39542 4.50962 9.67156L4.5096 14.3284C4.5096 14.461 4.56228 14.5882 4.65605 14.682C4.74981 14.7758 4.87699 14.8284 5.0096 14.8284L9.66648 14.8284C9.94262 14.8284 10.1665 14.6046 10.1665 14.3284C10.1665 14.0523 9.94261 13.8284 9.66647 13.8284L6.22921 13.8284L9.33419 10.7682C12.4075 7.73921 17.6127 9.26754 18.5606 13.4772L18.7739 14.4247C18.8346 14.6941 19.1022 14.8633 19.3716 14.8026C19.6409 14.742 19.8102 14.4744 19.7495 14.205L19.5362 13.2576Z"
      />
    </svg>
  )
})

export default Undo
